// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_close--white.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__message___Fshsx {
  color: white;
  flex: 1;
}

.styles__close___eByjc {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: contain;
  cursor: pointer;
  height: 15px;
  width: 15px;
}

.styles__bannerInner___D9VGn {
  font-size: 12px;
  justify-content: space-between;
  padding-bottom: 0;
  padding-top: 0;
  position: relative;
  width: 100%;
}

.styles__bannerType___XoY1B {
  left: 0;
  padding: 10px 0;
  position: fixed;
  right: 0;
  top: 60px;
  z-index: 1000;
}

.styles__success___qJY8D {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.styles__danger___FLpvR {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__warning___B2EtE {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
}

.styles__loaderWrapper___ELPHl {
  bottom: 0;
  height: 100px;
  left: 0;
  margin: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100px;
  z-index: 100;
}

.styles__overlay___U4gVw {
  bottom: 0;
  left: 0;
  opacity: 1;
  position: fixed;
  right: 0;
  top: 0;
}

.styles__loader___aooxT {
  bottom: 0;
  height: 30px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 90px;
}

.styles__bounce___lSecW {
  height: 30px;
  margin: auto;
  position: relative;
  width: 90px;
}

.styles__bounce___lSecW > div {
  animation: styles__bouncedelay___MhAVu 1.4s infinite ease-in-out;
  animation-fill-mode: both;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  border-radius: 100%;
  display: inline-block;
  height: 30px;
  width: 30px;
}

.styles__bounce___lSecW .styles__bounce1___T5CG7 {
  animation-delay: -0.32s;
}

.styles__bounce___lSecW .styles__bounce2___tUfHl {
  animation-delay: -0.16s;
}

@keyframes styles__bouncedelay___MhAVu {
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./universal/components/Notifications/styles.css"],"names":[],"mappings":"AAIA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,oEAAoE;EACpE,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EAEE,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,eAAe;EACf,eAAe;EACf,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EACE,wDAAmB;AAErB;;AAEA;EACE,wDAAiB;AAEnB;;AAEA;EACE,wDAAoB;AAEtB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,OAAO;EACP,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,OAAO;EACP,UAAU;EACV,eAAe;EACf,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EAEE,gEAAgD;EAEhD,yBAAyB;EACzB,8DAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EAEE,uBAAuB;AACzB;;AAcA;EACE;;;IAIE,mBAAmB;EACrB;;EAEA;IAEE,mBAAmB;EACrB;AACF","sourcesContent":["@value colors: \"styles/colors.css\";\n@value helpers: \"styles/helpers.css\";\n@value gtBlue, gtGreen, gtRed, gtYellow, gtBlueLight from colors;\n\n.message {\n  color: white;\n  flex: 1;\n}\n\n.close {\n  background: url('styles/img/icon_close--white.png') no-repeat center;\n  background-size: contain;\n  cursor: pointer;\n  height: 15px;\n  width: 15px;\n}\n\n.bannerInner {\n  composes: content-container row from helpers;\n  font-size: 12px;\n  justify-content: space-between;\n  padding-bottom: 0;\n  padding-top: 0;\n  position: relative;\n  width: 100%;\n}\n\n.bannerType {\n  left: 0;\n  padding: 10px 0;\n  position: fixed;\n  right: 0;\n  top: 60px;\n  z-index: 1000;\n}\n\n.success {\n  background: gtGreen;\n  composes: bannerType;\n}\n\n.danger {\n  background: gtRed;\n  composes: bannerType;\n}\n\n.warning {\n  background: gtYellow;\n  composes: bannerType;\n}\n\n.loaderWrapper {\n  bottom: 0;\n  height: 100px;\n  left: 0;\n  margin: auto;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100px;\n  z-index: 100;\n}\n\n.overlay {\n  bottom: 0;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  right: 0;\n  top: 0;\n}\n\n.loader {\n  bottom: 0;\n  height: 30px;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 90px;\n}\n\n.bounce {\n  height: 30px;\n  margin: auto;\n  position: relative;\n  width: 90px;\n}\n\n.bounce > div {\n  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;\n  animation: bouncedelay 1.4s infinite ease-in-out;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  background-color: gtBlue;\n  border-radius: 100%;\n  display: inline-block;\n  height: 30px;\n  width: 30px;\n}\n\n.bounce .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.bounce .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes bouncedelay {\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes bouncedelay {\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"helpers": `"styles/helpers.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"message": `styles__message___Fshsx`,
	"close": `styles__close___eByjc`,
	"bannerInner": `styles__bannerInner___D9VGn ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"bannerType": `styles__bannerType___XoY1B`,
	"success": `styles__success___qJY8D styles__bannerType___XoY1B`,
	"danger": `styles__danger___FLpvR styles__bannerType___XoY1B`,
	"warning": `styles__warning___B2EtE styles__bannerType___XoY1B`,
	"loaderWrapper": `styles__loaderWrapper___ELPHl`,
	"overlay": `styles__overlay___U4gVw`,
	"loader": `styles__loader___aooxT`,
	"bounce": `styles__bounce___lSecW`,
	"bouncedelay": `styles__bouncedelay___MhAVu`,
	"bounce1": `styles__bounce1___T5CG7`,
	"bounce2": `styles__bounce2___tUfHl`
};
export default ___CSS_LOADER_EXPORT___;
